<template>
 <b-container>
    <b-row class="mt-1">
      <b-col>
        <b-spinner v-if="loading" variant="primary"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-if="!loading" class="mt-4">
      <b-col>
        <h2 class="text-left">Hi {{firstName}},
          <span style="font-size: .75em; margin-left: 5px;" v-if="courses.length > 0">Here are the courses you are enrolled in.</span>
          <span style="font-size: .75em; margin-left: 5px;" v-if="courses.length === 0">You are not currently enrolled in any courses.</span>
        </h2>
        <course-card v-for="course in courses" :key="course.id" :course="course.course" :type="course.type"></course-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/api/Api'
import CourseCard from './components/CourseCard'

export default {
  name: 'Home',
  data () {
    return {
      loading: false,
      courses: [],
      timeZone: ''
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    },
    currentCourses () {
      return this.courses.filter((i) => i.inProgress)
    },
    upcomingCourses () {
      return this.courses.filter((i) => !i.inProgress)
    },
    mostRecentCourse () {
      if (this.courses != null && this.courses.length > 0) {
        return this.courses[0]
      } else {
        return null
      }
    },
    firstName () {
      try {
        return this.currentUser.name.split(' ')[0]
      } catch {
        return this.currentUser.name
      }
    }
  },
  created () {
    var vm = this
    vm.loading = true
    Api().get(`Users/${vm.currentUser.id}/Courses?page=1&pageSize=100&pastClasses=false`)
      .then((r) => {
        console.log(r.data)
        vm.courses = r.data.items
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.$router.push({ name: 'Login' })
        } else {
          console.log(e)
        }
      })
      .finally(() => {
        vm.loading = false
      })
  },
  components: {
    CourseCard
  }
}
</script>
